
import { MedicationRequest } from "../../../interfaces/pharmacy";

export const mockMedicationRequests: MedicationRequest[] = [
  {
    id: "REQ-001",
    patientName: "John Doe",
    medicationName: "Augmentin 625mg",
    dosage: "1 tablet every 12 hours",
    requestDate: "2023-10-27T10:00:00Z",
    status: "Pending",
  },
  {
    id: "REQ-002",
    patientName: "Jane Smith",
    medicationName: "Panadol 500mg",
    dosage: "2 tablets every 6 hours",
    requestDate: "2023-10-27T09:30:00Z",
    status: "Pending",
  },
  {
    id: "REQ-003",
    patientName: "Hassan Ali",
    medicationName: "Concor 5mg",
    dosage: "1 tablet daily",
    requestDate: "2023-10-26T15:00:00Z",
    status: "Approved",
  },
]; 